import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import I18N from '../classes/I18N';
import translations from '../lang/components/ImageSelector.lang.json';

const i18n = new I18N(translations);

const duration = 100;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',

    // change background colour if dragging
    // background: isDragging ? 'lightgreen' : 'grey',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

class ImageSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            hideVisibilityBtn: false
        }

        this.getFormattedImages = this.getFormattedImages.bind(this);
        this.handleOnDragEnd = this.handleOnDragEnd.bind(this);
        this.updateVisibility = this.updateVisibility.bind(this);
        this.hideVisBtn = this.hideVisBtn.bind(this);

        if (this.props.preload && this.props.preloadedImages.length) {
            this.state.images = this.props.preloadedImages;
            this.handleImageChange();
        } else {
            if (this.props.listing?.photos?.data && this.props.listing.photos.data.length) {
                this.state.images = this.getFormattedImages(true);
                this.handleImageChange();
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const manualListingChanged = this.props.listing?.manual && prevProps.listing?.manual && this.props.listing?.id !== prevProps.listing?.id;
        const nonManualListingChanged = prevProps.listing?.mlsid !== this.props.listing?.mlsid;
        if (this.props.listing?.photos?.data
            && this.props.listing.photos.data.length
            && (manualListingChanged || nonManualListingChanged)) {
            const imgs = this.getFormattedImages(true);
            this.setState({images: imgs});
            this.handleImageChange(imgs);
        }
    }

    handleImageChange = (images = null) => {
        if(!images) {
            this.props.onImagesChange(this.state.images);
        } else {
            this.props.onImagesChange(images);
        }
    }

    getFormattedImages(initial = false) {
        let images = [];
        let frame = 0;

        let imgs = [];
        if(this.props.listing?.enhancements?.data?.images && this.props.listing.enhancements.data.images.length) {
            imgs = this.props.listing.enhancements.data.images;
        } else if (this.props.listing?.imageUrls?.data?.length) {
            imgs = this.props.listing.imageUrls.data.map((image) => { return {url: image}});
        } else {
            imgs = this.props.listing.photos.data;
        }
        // eslint-disable-next-line
        for(const [index, value] of imgs.entries()) {

            if(initial && index === 0) {
                images.push({
                    url: value.url,
                    frameStart: frame,
                    duration: duration,
                    intro: true,
                    introImg: '../intro.svg',
                    outro: false,
                    selected: true,
                    show: true
                })
                frame += duration;
            }

            images.push({
                url: value.url,
                frameStart: frame,
                duration: duration,
                intro: false,
                outro: false,
                selected: false,
                show: (value.hidden) ? false : true
            });

            if(!value.hidden) {
                frame += duration;
            }
        }

        images.push({
            url: '../outro.svg',
            frameStart: frame,
            duration: duration,
            intro: false,
            outro: true,
            selected: false,
            show: true
        });

        return images;
    }

    updateSelected = (index) => {
        let imgs = this.state.images.map((item, i) => {
            item.selected = false;
            if(i === index) {
                item.selected = true;
            }
            return item;
        });

        this.setState({images: imgs});
        this.handleImageChange();
    }

    handleOnDragEnd(result) {
        let imgs = this.state.images;
        const item = imgs[result.source.index];
        imgs.splice(result.source.index, 1);

        imgs.splice(result.destination.index, 0, item);

        let frame = 0;
        imgs.forEach(img => {
            if(img.show) {
                img.frameStart = frame;
                frame += 100;
            }
        });
        this.setState({images: imgs, hideVisibilityBtn: false});
        this.handleImageChange();
    }

    updateVisibility(index) {
        let imgs = this.state.images;
        imgs[index].show = !imgs[index].show;
        let frame = 0;
        imgs.forEach(img => {
            if(img.show) {
                img.frameStart = frame;
                frame += 100;
            }
            return img;
        })
        this.setState({images: imgs});
        this.handleImageChange();
    }

    hideVisBtn() {
        this.setState({hideVisibilityBtn: true})
    }

    render() {
      return (
        <DragDropContext onDragEnd={this.handleOnDragEnd} onDragStart={this.hideVisBtn}>
            <Droppable droppableId='previewImgContainer' direction="horizontal">
                {(provided) => (
                    <ul className="previewImgContainer" {...provided.droppableProps} ref={provided.innerRef}>
                        {this.state.images.map((img, index) => {
                            return (
                                <Draggable key={`${img.url}-${index}`} draggableId={`${img.url}-${index}`} index={index}>
                                    {(provided, snapshot) => (
                                        <li className="previewImgLi" key={index}>
                                            <div className={`${!img.show ? 'imgWrap' : ''}`}>
                                                <img
                                                    src={img.intro ? img.introImg : img.url}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className={`previewImg ${img.selected ? 'selectedImg' : ''}`}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style,
                                                        img.show
                                                    )}
                                                    alt=""
                                                    onClick={() => this.updateSelected(index)}
                                                />
                                            </div>
                                            { !this.state.hideVisibilityBtn ? (<button className="showButton" onClick={() => this.updateVisibility(index)}>{img.show ? i18n.t(this.props.locale, 'hide') : i18n.t(this.props.locale, 'unhide')}</button>) : ('') }
                                        </li>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </ul>
                )}

            </Droppable>
        </DragDropContext>
      );
    }
}

export default ImageSelector;
